// projects/humanresources-personnel/src/assets/i18n/*/hr-per-degree.json
export class HrPerDegreeKey {
    private static readonly keyPrefix = 'hrPerDegree';
    public static title = `${HrPerDegreeKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerDegreeKey.keyPrefix}.pageHeader`;
    public static ofCadree = `${HrPerDegreeKey.keyPrefix}.ofCadree`;
    public static vestedRightWageDegree = `${HrPerDegreeKey.keyPrefix}.vestedRightWageDegree`;
    public static vestedRightWageRank = `${HrPerDegreeKey.keyPrefix}.vestedRightWageRank`;
    public static vestedRightWageIndicator = `${HrPerDegreeKey.keyPrefix}.vestedRightWageIndicator`;
    public static vestedAdditionalIndicator = `${HrPerDegreeKey.keyPrefix}.vestedAdditionalIndicator`;
    public static vestedAdvancementDate = `${HrPerDegreeKey.keyPrefix}.vestedAdvancementDate`;
    public static retirementDegree = `${HrPerDegreeKey.keyPrefix}.retirementDegree`;
    public static retirementRank = `${HrPerDegreeKey.keyPrefix}.retirementRank`;
    public static retirementIndicator = `${HrPerDegreeKey.keyPrefix}.retirementIndicator`;
    public static retirementAdditionalIndicator = `${HrPerDegreeKey.keyPrefix}.retirementAdditionalIndicator`;
    public static retirementAdvancementDate = `${HrPerDegreeKey.keyPrefix}.retirementAdvancementDate`;
    public static salaryDegree = `${HrPerDegreeKey.keyPrefix}.salaryDegree`;
    public static salaryRank = `${HrPerDegreeKey.keyPrefix}.salaryRank`;
    public static salaryIndicator = `${HrPerDegreeKey.keyPrefix}.salaryIndicator`;
    public static salaryAdditionalIndicator = `${HrPerDegreeKey.keyPrefix}.salaryAdditionalIndicator`;
    public static advancementStopDate = `${HrPerDegreeKey.keyPrefix}.advancementStopDate`;
    public static reasonStopCode = `${HrPerDegreeKey.keyPrefix}.reasonStopCode`;
    public static reasonStopId = `${HrPerDegreeKey.keyPrefix}.reasonStopId`;
    public static retirementHeader = `${HrPerDegreeKey.keyPrefix}.retirementHeader`;
    public static vestedRightHeader = `${HrPerDegreeKey.keyPrefix}.vestedRightHeader`;
    public static salaryHeader = `${HrPerDegreeKey.keyPrefix}.salaryHeader`;
    public static header = `${HrPerDegreeKey.keyPrefix}.header`;
    public static rankHeader = `${HrPerDegreeKey.keyPrefix}.rankHeader`;
    public static indicatorHeader = `${HrPerDegreeKey.keyPrefix}.indicatorHeader`;
    public static additionalIndicatorHeader = `${HrPerDegreeKey.keyPrefix}.additionalIndicatorHeader`;
    public static advancementDateHeader = `${HrPerDegreeKey.keyPrefix}.advancementDateHeader`;
    public static salaryAdvancementDate = `${HrPerDegreeKey.keyPrefix}.salaryAdvancementDate`;
    public static rank = `${HrPerDegreeKey.keyPrefix}.rank`;
    public static rankDegree = `${HrPerDegreeKey.keyPrefix}.rankDegree`;
    public static rankDegrees = `${HrPerDegreeKey.keyPrefix}.rankDegrees`;
}
